import { isDefined, isNull } from "Utils/functions";

import { UserIdentificationData } from "Store/userIdentification";

export const YOUNGER_DRIVER_AGE_LIMIT = 23;

export const isYoungUser = (
  user: UserIdentificationData | null,
  carOwnerAge: number | undefined,
): boolean => {
  if (isDefined(carOwnerAge) && carOwnerAge < YOUNGER_DRIVER_AGE_LIMIT) {
    return true;
  }

  if (isNull(user)) {
    return false;
  }

  const age = Number(user.newCustomerResponse.age);
  return age !== 0 && age < YOUNGER_DRIVER_AGE_LIMIT;
};
